/* global fetch */

import { config } from '../config';
import { headers, APIResponse, stleaf, fetchAPI, SpanTag } from '../helpers';

export const getOne = (st: SpanTag, slug: string): Promise<APIResponse> => {
  const url = `${config.API_URL}/v1/pilots/${slug}`;
  return fetchAPI(stleaf(st, 'zaeb7x'), url, {
    method: 'GET',
    credentials: 'include',
    headers,
  });
};

export const getCredentials = (
  st: SpanTag,
  id: string,
): Promise<APIResponse> => {
  const url = `${config.API_URL}/v1/pilots/${id}/credentials`;
  return fetchAPI(stleaf(st, 'shei3v'), url, {
    method: 'GET',
    credentials: 'include',
    headers,
  });
};

export const getSoftware = (st: SpanTag, id: string): Promise<APIResponse> => {
  const url = `${config.API_URL}/v1/pilots/${id}/software`;
  return fetchAPI(stleaf(st, 'guo9fi'), url, {
    method: 'GET',
    credentials: 'include',
    headers,
  });
};

export const getExperience = (
  st: SpanTag,
  id: string,
): Promise<APIResponse> => {
  const url = `${config.API_URL}/v1/pilots/${id}/experience`;
  return fetchAPI(stleaf(st, 'ipah6o'), url, {
    method: 'GET',
    credentials: 'include',
    headers,
  });
};

export const getMedia = (st: SpanTag, id: string): Promise<APIResponse> => {
  const url = `${config.API_URL}/v1/pilots/${id}/media`;
  return fetchAPI(stleaf(st, 'mo0woh'), url, {
    method: 'GET',
    credentials: 'include',
    headers,
  });
};
